module.exports = {
  siteUrl: process.env.GATSBY_BASE_URI,
  mapboxApiKey: process.env.MAPBOX_API_KEY,
  iframelyApiKey: process.env.IFRAMELY_API_KEY,
  livePagePostsLimit: 12,
  sanityProjectId: "aojlc0g3",
}
